function format(value, format, lng, options) {
  if (format === 'percent') {
    return new Intl.NumberFormat(lng, { style: 'percent' }).format(value);
  }
  if (format === 'length_cm') {
    return Intl.NumberFormat(lng, { style: 'unit', unit: 'centimeter', maximumFractionDigits: 0 }).format(value);
  }
  if (format === 'length_ft_in' && options) {
    const ft = Intl.NumberFormat(lng, { style: 'unit', unit: 'foot' }).format(options.value_ft);
    const inches = Intl.NumberFormat(lng, { style: 'unit', unit: 'inch' }).format(options.value_in);
    return `${ft} ${inches}`;
  }
  return value;
}

exports.format = format;
